import { render, staticRenderFns } from "./SoftWaterView.vue?vue&type=template&id=efc00c12&"
import script from "./SoftWaterView.vue?vue&type=script&lang=js&"
export * from "./SoftWaterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports